const images = [
  "wait.png",
  "fond-form-min.png",
  "fond-fom2.png",
  "CTA.png",
  "CTA2.png",
  "deco-mob.png",
  "panneau-mob.png",
  "home-mob.png",
  "bottom-mob.png",
  "br-mob.png",
  "coussin-mob.png",
  "voyage-mob.png",
  "finish-mob.png",
  "404mob.png",
  "voyage.png",
  "coussin.png",
  "tapis.png",
  "tapis-mob.png",
  "br.png",
  "logo.png",
  "finish.png",
  "404.png",
  "fond.png",
  "home.png",
  "fond.jpg",
];

export function preloadImages() {
  return Promise.all(
    images.map((image) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = require(`@/assets/images/${image}`);
        img.onload = resolve;
        img.onerror = reject;
      });
    })
  );
}
